import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { IArenaDto } from '@models/arena/dtos/arena-dto';
import { ModalSpaceDto } from '@models/arena/dtos/modal-space-dto';
import { ISimpleStepParameterizationDto } from '@models/competition/step-paramaterization/dtos/simple-step-parametrization-dto';
import { ClashDto } from '@models/embate/clash-dto';
import { ClashByHourDto, GamesTableDto } from '@models/embate/games-table-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { DateTimeEnum } from '@shared/components/date-time-picker/date-time-picker.component';
import { ArenaService } from '@shared/services/arena.service';
import { ClashService } from '@shared/services/competition/clash.service';
import { StepParameterizationService } from '@shared/services/competition/step-parametrization.service';
import { distinctUntilChanged, first, firstValueFrom, Subject } from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import {
  FilterFormValue,
  FilterGamesTableService,
  FilterNavigationState,
  OptionsFilterFormValue,
} from './services/filter-games-table.service';
import { CompetitionBlockService } from '@shared/services/competition-block.service';
import { EventService } from '@shared/services/event.service';
import { ICompetitionDto } from '@models/competition-dto';
import { IEventDto } from '@models/event-dto';

@Component({
  selector: 'sigecom-filter-games-table',
  templateUrl: './filter-games-table.component.html',
  styleUrls: ['./filter-games-table.component.scss'],
})
export class FilterGamesTableComponent
  extends BaseComponent
  implements OnInit
{
  //filtro que guarda todos ID
  filterGamesTable: FormGroup;

  arenaTxNome?: string;
  arenaPageable = { page: 0, size: 3 };

  petTxNome = '';


  selectedArena?: IArenaDto;

  @Input() isEditingFight: boolean = false;
  @Input() isIndependentFilter: boolean = false;
  @Input() isFromStep: boolean = false;
  @Input() isPrincipalFilter: boolean = false;
  @Input() gamesTableEdit?: GamesTableDto;
  @Input() clashByHourEdit?: ClashByHourDto;
  @Input() filterFromStep?: FilterNavigationState;
  @Output() initTableGamesSaved = new EventEmitter<FilterFormValue>();

  faseOptions?: IPage<ISimpleStepParameterizationDto>;
  clashOptions?: IPage<ClashDto>;
  eventOptions?: IPage<IEventDto>;
  competitionOptions?: IPage<ICompetitionDto>;
  eventTxNome?: string;
  arenaOptions?: IPage<IArenaDto>;
  spaceOptions?: ModalSpaceDto[];

  DateTimeEnum = DateTimeEnum;

  filterNavigation?: FilterNavigationState;

  @Input() customClass?: string;
  @Input() petNrId: number | null = null;

  constructor(
    public filterGamesTableService: FilterGamesTableService,
    private stepParametrizationService: StepParameterizationService,
    private clashService: ClashService,
    private arenaService: ArenaService,
    private eventService: EventService,
    private competitionBlockService: CompetitionBlockService,
    private cd: ChangeDetectorRef,
  ) {
    super();
    this.filterGamesTable = this.fb.group({
      evento: this.fb.control<number | null>(null),
      competicao: this.fb.control<number | null>(null),
      fase: this.fb.control<number | null>(this.petNrId, Validators.required),
      chave: this.fb.control<number | null>(null, Validators.required),
      local: this.fb.control<number | null>(null, Validators.required),
      espaco: this.fb.control<number | null>(null, Validators.required),
      competitionDate: this.fb.control<string | null>(
        null,
        Validators.required,
      ),
      competitionHour: this.fb.control<string | null>(
        null,
        Validators.required,
      ),
    });
  }

  ngOnInit(): void {
    console.log('customclass', this.customClass);

    //OBS: O CHAMADO FILTRO INDEPENDENTE SE REFERE AO FILTRO QUE APARECE NA EDIÇÃO DE ALGUM EMBATE.
    //ELE NÃO COMPARTILHA SEUS VALORES COM OS OUTROS FILTROS PARA NÃO PERDEMOS OS ESTADOS DOS FILTROS PRINCIPAIS.

    this.initFilterFromFaseNavigation(); //EXECUTA INSTRUÇÕES PARA CARREGAR O FILTRO VINDO DA FASE.
    this.loadOptionsPaginate(); // CARREGA OPÇÕES DE COMPETIÇÃO E ARENA QUE SÃO AS ÚNICAS PAGINADAS.
    this.loadValuesEditFight(); // PREENCHE O FILTRO INDEPENDENTE(EDIÇÃO) QUANDO CLICAMOS EM EDITAR UM CONFRONTO COM AS INFORMAÇÕES DA TABELA.
    this.initSharedFilter(); // ESCUTA AS MUDANÇAS NO FILTERGAMESTABLE PARA ATUALIZAR O SERVIÇO E MANTER O FILTRO COMPARTILHADO COM
    // O FILTRO DE EMBATE.
  }

  private loadOptionsPaginate() {
    this.loadArenaOptions();
    this.loadFaseOptions();
    this.loadEventOptions();
  }

  private loadFaseOptions(page=0) {
    this.stepParametrizationService
      .getSimpleStepParametrization$({petTxNome: this.petTxNome}, PageRequest.of(page, 20))
      .pipe(this.takeUntilDestroy())
      .subscribe((fases) => {
        this.faseOptions = fases;
        this.updateServiceOptions();
      });
  }
  searchFaseChange(text: string) {
    this.petTxNome = text;
    this.loadFaseOptions();
  }
  changeFasePage(page: number) {
    this.loadFaseOptions(page);
  }

  private loadEventOptions(page = 0): void {
    this.eventService
      .getAllEventsBasicData(page, 10, { eveTxNome: this.eventTxNome })
      .pipe(this.takeUntilDestroy())
      .subscribe((events) => {
        this.eventOptions = events;
        this.updateServiceOptions();
      });
  }

  eventSearchChange(text: string) {
    this.eventTxNome = text;
    this.loadEventOptions();
  }

  changeEventPage(page: number) {
    this.loadEventOptions(page);
  }

  private loadValuesEditFight() {
    this.filterGamesTableService.editFightValue$
      .pipe(
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
        first(),
        this.takeUntilDestroy(),
      )
      .subscribe(async (isEditing) => {
        if (isEditing && this.gamesTableEdit && this.clashByHourEdit) {
          const petNrId = this.clashByHourEdit.chaveEmbateSimplesDto.petNrId;
          const cheNrId = this.clashByHourEdit.chaveEmbateSimplesDto.cheNrId;
          const areNrId = this.gamesTableEdit.areNrId;
          const epcNrId = this.gamesTableEdit.epcNrId;

          await this.loadAllOptions({
            fase: petNrId,
            chave: cheNrId,
            arena: areNrId,
            espaco: epcNrId,
            competitionDate: null,
            competitionHour: null,
            evento: null,
            competicao: null,
          });

          this.cd.detectChanges();

          this.filterGamesTable.patchValue(
            {
              fase: petNrId,
              chave: cheNrId,
              espaco: epcNrId || null,
              competitionDate:
                this.gamesTableEdit?.embDtEmbate?.toString() || null,
              competitionHour: this.clashByHourEdit?.embTmEmbate || null,
            },
            { emitEvent: false },
          );

          ['fase', 'chave'].forEach((ctrl) =>
            this.filterGamesTable.get(ctrl)?.disable({ emitEvent: false }),
          );

          this.filterGamesTableService.updateFilterIndependentForm(
            this.filterGamesTable.getRawValue(),
          );
        }
      });
  }

  private initFilterFromFaseNavigation() {
    if (this.isEditingFight) return;

    if (this.isPrincipalFilter) {
      this.activatedRoute.queryParams.subscribe((params) => {
        const filter = params['filter'];
        if (filter) {
          const obj = JSON.parse(filter);
          this.filterNavigation = obj as FilterNavigationState;
          this.cleanAllFilters();
          this.loadAllOptionsFromFaseNavigation(this.filterNavigation!);
          return;
        }
        this.loadInitFilterSaved(); //BUSCA VALORES SALVOS NO STORAGE , CASO EXISTAM ELE CARREGA
      });
    }
  }

  private async loadAllOptionsFromFaseNavigation(
    filter: FilterNavigationState,
  ) {
    if (this.isIndependentFilter) return;

    const clashes = await firstValueFrom(
      this.clashService.getClashs(
        { petNrId: filter.petNrId! },
        { page: 0, size: 999 },
      ),
    );
    this.clashOptions = clashes;

    this.updateServiceOptions();

    this.cd.detectChanges();

    this.filterGamesTable.patchValue({
      fase: filter.petNrId,
      chave: filter.cheNrId,
      espaco: null,
      local: null,
      competitionDate: null,
      competitionHour: null,
    });

    this.filterNavigation = undefined;
    this.filterGamesTableService.selectedArena.set(undefined);
  }

  private async loadAllOptions(filter: FilterFormValue) {
    if (filter.arena) {
      const arena = await firstValueFrom(
        this.arenaService.findArenasById$(filter.arena!),
      );
      this.isEditingFight
        ? (this.selectedArena = arena)
        : this.filterGamesTableService.selectedArena.set(arena);
      this.spaceOptions = arena.espacoDtos;
    }

    if (filter.fase) {
      const clashes = await firstValueFrom(
        this.clashService.getClashs(
          { petNrId: filter.fase! },
          { page: 0, size: 999 },
        ),
      );
      this.clashOptions = clashes;
    }

    if (filter.evento) {
      await this.loadCompetitionsForEvent(filter.evento);
    }
  }
  private async loadInitFilterSaved() {
    if (this.isIndependentFilter) return;

    const filterValue =
      this.filterGamesTableService.getCurrentFilterFormValue();
    await this.loadAllOptions(filterValue);

    this.cd.detectChanges();

    this.filterGamesTable.patchValue(
      {
        fase: filterValue.fase,
        chave: filterValue.chave,
        espaco: filterValue.espaco,
        competitionDate: filterValue.competitionDate,
        competitionHour: filterValue.competitionHour,
        evento: filterValue.evento,
        competicao: filterValue.competicao,
      },
      { emitEvent: false },
    );

    if (filterValue.arena || filterValue.fase)
      this.initTableGamesSaved.emit(filterValue);
  }

  private initSharedFilter() {
    this.filterGamesTableService.optionsFilterFormValue$
      .pipe(this.takeUntilDestroy())
      .subscribe({
        next: (value) => {
          this.loadAllDependentOptions(value);
        },
      });

    this.filterGamesTable.valueChanges
      .pipe(this.takeUntilDestroy())
      .subscribe((value) => {
        if (!this.isIndependentFilter) {
          this.filterGamesTableService.updateFilterForm(value);
        } else {
          const rawValue = this.filterGamesTable.getRawValue();
          this.filterGamesTableService.updateFilterIndependentForm(rawValue);
        }
      });

    this.filterGamesTableService.filterFormValue$
      .pipe(
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
        this.takeUntilDestroy(),
      )
      .subscribe((value) => {
        if (!this.isIndependentFilter) {
          this.cd.detectChanges();

          this.updateServiceOptions();

          this.filterGamesTable.patchValue(
            {
              fase: value?.fase,
              chave: value?.chave,
              espaco: value?.espaco,
              competitionDate: value?.competitionDate,
              competitionHour: value?.competitionHour,
              evento: value?.evento,
              competicao: value?.competicao,
            },
            { emitEvent: false },
          );

          //LIDANDO COM OS VALORES DOS DROPDOWNS PAGINADOS!!
          const selectedArena = this.filterGamesTableService.selectedArena();
          if (selectedArena) {
            const arenaContent = this.arenaOptions?.content;
            const exist = arenaContent?.some(
              (are) => are.areNrId === selectedArena?.areNrId,
            );
            if (arenaContent && !exist) arenaContent.push(selectedArena);
            this.filterGamesTable
              .get('local')
              ?.patchValue(selectedArena.areNrId, { emitEvent: false });
          }
        }
      });
  }

  private updateServiceOptions() {
    this.filterGamesTableService.updateOptionsFilterFormValue({
      faseOptions: this.faseOptions,
      clashOptions: this.clashOptions,
      arenaOptions: this.arenaOptions,
      spaceOptions: this.spaceOptions,
      eventOptions: this.eventOptions,
      competitionOptions: this.competitionOptions,
    });
  }
  setPetNrId(petNrId: number) {
    this.petNrId = petNrId;
    this.handleClashsOptionsChange();
  };
  cheTxNome=''
  handleClashsOptionsChange(page=0) {
    if (this.petNrId) {
      this.clashService
        .getClashs({ petNrId: this.petNrId, cheTxNome: this.cheTxNome}, { page: 0, size: 999 })
        .pipe(this.takeUntilDestroy())
        .subscribe((value) => {
          this.clashOptions = value;
          this.updateServiceOptions();
        });
    }

    this.filterGamesTable.get('chave')?.patchValue(null, { emitEvent: false });
  }
  searchClashChange(text: string) {
    this.cheTxNome = text;
    this.handleClashsOptionsChange();
  }
  changeClashPage(page: number) {
    this.handleClashsOptionsChange(page);
  }

  loadArenaOptions(page=0) {
    this.arenaService
      .findArenas$(
        { areTxNome: this.arenaTxNome },
        { page: page, size: 3 },
      )
      .pipe(this.takeUntilDestroy())
      .subscribe({
        next: (response) => {
          this.arenaOptions = response;
        },
      });
  }

  handleSpacesOptionsChange(areNrId: number) {
    this.filterGamesTable.get('espaco')?.patchValue(null, { emitEvent: false });
    this.spaceOptions = this.arenaOptions?.content?.find(
      (arena) => arena.areNrId === areNrId,
    )?.espacoDtos;

    if (!this.isEditingFight) this.updateServiceOptions();
  }

  private loadAllDependentOptions(
    optionsFilterFormValue: OptionsFilterFormValue,
  ): void {
    this.faseOptions = optionsFilterFormValue.faseOptions;
    this.clashOptions = optionsFilterFormValue.clashOptions;
    this.arenaOptions = optionsFilterFormValue.arenaOptions;
    this.spaceOptions = optionsFilterFormValue.spaceOptions;
    this.eventOptions = optionsFilterFormValue.eventOptions;
    this.competitionOptions = optionsFilterFormValue.competitionOptions;
  }

  cleanAllFilters() {
    this.filterGamesTableService.selectedArena.set(undefined);
    this.filterGamesTable.reset();
    this.competitionOptions = undefined;
    this.updateServiceOptions();
  }

  cleanCompetitonHour() {
    this.filterGamesTable.get('competitionHour')?.patchValue(null);
  }
  isRequired(key: string): boolean {
    return this.filterGamesTable.controls[key].hasValidator(
      Validators.required,
    );
  }
  arenaPageChange(page: number) {
    this.loadArenaOptions(page);
  }
  arenaSearchChange(name: string) {
    this.arenaTxNome = name;
    this.loadArenaOptions();
  }

  handleArenaChange(arena: IArenaDto | undefined): void {
    if (this.isEditingFight) {
      this.selectedArena = arena;
    } else {
      this.filterGamesTableService.selectedArena.set(arena);
    }
    this.handleSpacesOptionsChange(arena?.areNrId!);
  }

  handleEventChange(eveNrId: number | undefined) {
    this.filterGamesTable
      .get('competicao')
      ?.patchValue(null, { emitEvent: false });
    this.competitionOptions = undefined;
    this.updateServiceOptions();

    if (eveNrId) {
      this.loadCompetitionsForEvent(eveNrId);
    }
  }

  private async loadCompetitionsForEvent(eveNrId: number): Promise<void> {
    const blocks = await firstValueFrom(
      this.competitionBlockService.getAllBlocoCompByEventId(eveNrId, 0, 999),
    );

    const blockIds = blocks.content?.map((b) => b.bloNrId!) ?? [];

    if (blockIds.length === 0) {
      this.competitionOptions = {
        content: [],
      } as unknown as IPage<ICompetitionDto>;
      this.updateServiceOptions();
      return;
    }

    const competitionsPerBlock = await Promise.all(
      blockIds.map((bloNrId) =>
        firstValueFrom(
          this.competitionBlockService.getAllCompetitionByBlocks(
            bloNrId,
            0,
            999,
          ),
        ),
      ),
    );

    const merged = competitionsPerBlock.flatMap((page) => page.content ?? []);
    const uniqueCompetitions = merged.filter(
      (comp, index, self) =>
        index === self.findIndex((c) => c.comNrId === comp.comNrId),
    );

    this.competitionOptions = {
      content: uniqueCompetitions,
    } as unknown as IPage<ICompetitionDto>;
    this.updateServiceOptions();
  }
}
